export function afterHoursNav() {
    const triggers = document.querySelectorAll<HTMLElement>('[data-nav-trigger]');
    const panels = document.querySelectorAll<HTMLElement>('[data-nav-panel]');

    function toggleNav(trigger: HTMLElement) {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

        triggers.forEach(t => t.setAttribute('aria-expanded', 'false'));
        panels.forEach(p => p.setAttribute('aria-hidden', 'true'));

        if (!isExpanded) {
            trigger.setAttribute('aria-expanded', 'true');
            const panel = document.querySelector<HTMLElement>('[data-nav-panel]');
            if (panel) {
                panel.setAttribute('aria-hidden', 'false');
            }
        }
    }

    function closeNav() {
        triggers.forEach(t => t.setAttribute('aria-expanded', 'false'));
        panels.forEach(p => p.setAttribute('aria-hidden', 'true'));
    }

    triggers.forEach(trigger => {
        trigger.addEventListener('click', () => toggleNav(trigger));
    });

    document.addEventListener('click', (e) => {
        const target = e.target as Node;
        const isInsideNav = Array.from(triggers).some(t => t.contains(target)) ||
            Array.from(panels).some(p => p.contains(target));

        if (!isInsideNav) {
            closeNav();
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeNav();
        }
    });
}
